module.exports = __webpack_public_path__ + "img/icono-12-2.95a9d856.png";